<template>
  <div>
    <v-card v-if="notFound" flat>
      <v-card-text>
        <v-card-text>
          <div class="text-center title">This link is expire.</div>
        </v-card-text>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto" flat max-width="600" v-if="!cardCollected">
      <div class="text-center mt-4" v-if="Info">
        <img v-if="Info.Business.imageUrl" height="50" :src="Info.Business.imageUrl" alt="Logo" />

        <div class="text-h5">{{ Info.Business.name }}</div>
        <div>{{ Info.Business.phoneNumber }}</div>
      </div>

      <!-- <v-card-text v-if="Info && Info.Donor">
        <div class="font-weight-bold">- Donor</div>
        <div>
          <div>
            Name: <span class="font-weight-bold">{{ Info.Donor.name }}</span>
          </div>
          <div>
            Name:
            <span class="font-weight-bold">{{ Info.Donor.phoneNumber }}</span>
          </div>
        </div>
      </v-card-text> -->

      <v-card-text v-if="Info && Info.message">
        <div class="text-center">
          <div class="mb-2 font-weight-bold">
            Message from {{ Info.Business.name }}
          </div>
          <div>{{ Info.message }}</div>
        </div>
      </v-card-text>

      <v-card-text v-if="Info">

        <v-row>
          <v-col cols="12">
            <v-text-field outlined :error-messages="nameErrors" :hide-details="nameErrors.length === 0" dense
              v-model="name" label="Name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined @change="fixEmail" :error-messages="emailErrors"
              :hide-details="emailErrors.length === 0" dense v-model="email" label="Email Address"></v-text-field>
          </v-col>
        </v-row>

        <v-col cols="12" class="py-2">
          <div class="mb-2 text-center">How you like to pay?</div>
        </v-col>

        <CreditCard @submit="paymentCollected" :localCollectOnly="true"  :public="true" :donor="Info.Donor" :sponsor="sponsor"
        :donationCategoryId="Info.Business.DefaultDonationId"
        />

        <v-card-actions>
          <v-btn @click="submit" :loading="loading" color="primary" width="150" block large>Submit</v-btn>
        </v-card-actions>


      </v-card-text>

      <v-card-actions>
        <div class="text-right">
          Power by: <span>taleem.app</span> -
          <span class="caption">{{ version }}</span>
        </div>
      </v-card-actions>
    </v-card>
    <v-card v-else flat>
      <div class="text-center mt-4" v-if="Info">
        <img v-if="Info.Business.imageUrl" height="50" :src="Info.Business.imageUrl" alt="Logo" />

        <div class="text-h5">{{ Info.Business.name }}</div>
        <div>{{ Info.Business.phoneNumber }}</div>
      </div>
      <v-card-text>
        <lottie :height="200" :options="defaultOptions" name="receiptCheck" v-on:animCreated="handleAnimation"
          @onComplete="done" />
        <div v-if="showValue" class="text-center">
          <div class="text-h5">All Set</div>
          <div class="mt-3">
            O Allah send prayers upon the family of [ the giver of charity ]
            <span class="font-weight-bold">Bukhari Hadith - 1497</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import donorService from "@/modules/Donors/service.js";
import CreditCard from '@/modules/PaymentMethod/components/CreditCard.vue'
import Lottie from "@/components/lottie.vue";
const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");
import * as animationData from "@/assets/lottie/1708-success.json";
const pjson = require("../../../../package.json");

export default {
  name: "card-collect-donor",
  data() {
    return {
      sponsor: {
        name: null,
        email: null,
      },
      name: null,
      email: null,
      notFound: false,
      loading: false,
      StripeKey: null,
      showValue: false,
      cardCollected: false,
      Info: null,
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    name: {
        required,
      },
      email: {
        required,
        email,
      },
  },
  components: {
    CreditCard,
    Lottie,
  },
  created() {
    this.loadData();
  },
  computed: {
    stopLoading() {
      return !this.loading;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.required) errors.push("Email address is required");
      if (!this.$v.email.email) errors.push("Email is not valid");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) errors.push("Name is required");
      return errors;
    },
    version() {
      return pjson.version;
    },
    // StripeKey() {
    //   let key = null
    //   if (process.env.NODE_ENV === 'production' && this.Info && this.Info.Bussiness) {
    //     key =  this.Info.Business.metadata.liveStripeId
    //   } else {
    //     if (this.Info && this.Info.Business) {
    //       key = this.Info.Business.metadata.testStripeId
    //     }

    //   }
    //   return key
    // },
  },
  methods: {
    fixEmail() {
      this.email = this.email.toLowerCase().trim();
    },
    done() {
      this.showValue = true;
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    submit() {
      this.Info.Donor.name = this.name
      this.Info.Donor.email = this.email
      this.sponsor.name = this.name
      this.sponsor.email = this.email
      this.$events.emit("submitCreditCard");
    },
    paymentCollected(event) {
      console.log('localCollectOnly', event)
      this.cardCollected = true;
      this.loading = true;
      donorService
        .PaymentInfoMarkCollected(this.Info.id, {
          donorPaymentRequest: this.Info,
          sponsor: this.sponsor,
          card: event
        })
        .then((response) => {
          this.loading = false;
          console.log("response", response);
          this.cardCollected = true;
        })
        .catch(error => {
          console.log('error updating mark collect', error)
          this.loading = false;
          this.$Progress.finish();
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: error.data ? error.data.message : error.message,
            });

        })
    },
    submit1(token) {
      console.log("val", token, this.Info);
      this.loading = true;
      donorService
        .PaymentInfoMarkCollected(this.Info.id, {
          donorPaymentRequest: this.Info,
          data: token,
        })
        .then((response) => {
          this.loading = false;
          console.log("response", response);
          this.cardCollected = true;
        })
        .catch(error => {
          console.log('error updating mark collect', error)
          this.loading = false;
          this.$Progress.finish();
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: error.data ? error.data.message : error.message,
            });

        })
    },
    loadData() {
      let id = this.$route.params.id;

      return donorService
        .getPaymentReqById(id)
        .then((response) => {
          console.log("response", id, response);
          if (response.data) {
            console.log("as;dlkjfa;slkdfjsa;ldk", response);
            this.Info = response.data;
            this.name = this.Info.Donor.name;
            this.email = this.Info.Donor.email;
            // this.StripeKey = this.Info.Business.metadata.publicStripeId;
            // this.cardCollected = this.Info.isCollected;
            document.title = this.Info.Business.name;
          } else {
            console.log("asdkfjaslkdfjlaksjdf;lkasjdf");
            this.notFound = true;
          }

          // this.Donor = response.data;
          // console.log('response.data.alert', response)
          // if (response.data && !response.data.alert) response.data.alert = false
          this.$Progress.finish();
        })
        .catch(() => {
          this.$Progress.finish();
        });
    },
  },
};
</script>

<style scoped></style>